import React from 'react';
import { motion } from 'framer-motion';
interface ProductSelectorProps {
  products: Array<{
    id: string;
    name: string;
    icon: string;
  }>;
  selectedProduct: string;
  onSelectProduct: (productId: string) => void;
}
export function ProductSelector({
  products,
  selectedProduct,
  onSelectProduct
}: ProductSelectorProps) {
  return <div className="flex flex-col gap-3" data-id="element-104">
      <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-2" data-id="element-105">
        Product Type
      </h2>
      {products.map(product => {
      const isSelected = selectedProduct === product.id;
      return <motion.button key={product.id} onClick={() => onSelectProduct(product.id)} className={`
              relative px-6 py-4 rounded-lg text-left transition-colors
              ${isSelected ? 'bg-black text-white' : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'}
            `} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-106">
            <div className="flex items-center gap-3" data-id="element-107">
              <span className="text-2xl" data-id="element-108">{product.icon}</span>
              <span className="font-medium" data-id="element-109">{product.name}</span>
            </div>
            {isSelected && <motion.div layoutId="activeProduct" className="absolute inset-0 border-2 border-black rounded-lg" transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} data-id="element-110" />}
          </motion.button>;
    })}
    </div>;
}